import { render, staticRenderFns } from "./SignatoryInfo.vue?vue&type=template&id=3fbe43c0"
import script from "./SignatoryInfo.vue?vue&type=script&lang=js"
export * from "./SignatoryInfo.vue?vue&type=script&lang=js"
import style0 from "./SignatoryInfo.vue?vue&type=style&index=0&id=3fbe43c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports